import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateTreatmentReport, type TreatmentReportUpdatePayload } from '@/services/main/treatmentReport';
import { useClinicContext } from './useClinicContext';
import { useClinicPortalServiceType } from './clinicPortalServiceType';

export const useUpdateTreatmentReport = (patientId?: string) => {
  const { tenant, clinicNumber } = useClinicContext();
  const serviceType = useClinicPortalServiceType();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: string | number; data: TreatmentReportUpdatePayload }) =>
      updateTreatmentReport(
        tenant! || '',
        clinicNumber! || '',
        patientId!,
        String(id),
        serviceType,
        data
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['treatment-reports'] });
      queryClient.invalidateQueries({ queryKey: ['rezept', 'list', tenant, clinicNumber] });
    },
  });
};
